// BillingWorkflowLanding.tsx
import { PageHeader } from "@shared/components/PageHeader";
import { Stepper } from "@shared/components/Stepper";
import { ArrowLeft } from "lucide-react";
import { useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Step6ApproveBills from "./steps/ApproveBills/ApproveBills";
import Step1BillingConfiguration from "./steps/BillCycle/BillCycle";
import Step2FetchConsumerData from "./steps/ConsumerData/ConsumerData";
import Step4GenerateBill from "./steps/GenerateBill/GenerateBill";
import Step3FetchMeterReadings from "./steps/MeterReading/MeterReading";
import Step5ReviewBills from "./steps/ReviewBills/ReviewBills";

const BulkBillCreate = () => {
  const [workflowData, setWorkflowData] = useState({});
  const navigate = useNavigate();
  const { action } = useParams();

  const handleComplete = (
    allStepData: any,
    completedSteps: number[],
    skippedSteps: number[]
  ) => {
    // Handle final submission
  };

  const stepperSteps = [
    {
      id: "billing-config",
      description: "Billing Cycle Setup",
      component: <Step1BillingConfiguration />,
      slug: "billing-config",
    },
    {
      id: "fetch-consumer",
      description: "Fetch Consumer Data",
      component: <Step2FetchConsumerData />,
      slug: "fetch-consumer",
    },
    {
      id: "fetch-meter",
      description: "Fetch Readings",
      component: <Step3FetchMeterReadings />,
      slug: "fetch-meter",
    },
    {
      id: "generate-bill",
      description: "Generate Bill",
      component: <Step4GenerateBill />,
      slug: "generate-bill",
    },
    {
      id: "review-bills",
      description: "Review Bills",
      component: <Step5ReviewBills />,
      slug: "review-bills",
    },
    {
      id: "approve-bills",
      description: "Approve Bills",
      component: <Step6ApproveBills />,
      slug: "approve-bills",
    },
  ];

  // When resuming a draft, pre-mark all steps before the current one as completed
  const initialCompletedSteps = useMemo(() => {
    if (action !== "edit") return [];
    const hash = window.location.hash.replace("#", "");
    if (!hash) return [];
    const currentStepIndex = stepperSteps.findIndex((s) => s.slug === hash);
    if (currentStepIndex <= 0) return [];
    // All steps before the current one are "completed"
    return Array.from({ length: currentStepIndex }, (_, i) => i);
  }, [action]);

  return (
    <div>
      <div className="flex items-center gap-3 p-2">
        <ArrowLeft
          className="w-5 h-5 cursor-pointer text-gray-700"
          onClick={() => navigate("/bx/create-bill-generation")}
        />
        <PageHeader
          title="Billing Workflow"
          subtitle="Create and manage billing cycles using this streamlined workflow"
        />
      </div>

      {/* Stepper Content */}
      <div className="flex-1 overflow-y-auto p-2">
        <Stepper
          steps={stepperSteps}
          onComplete={handleComplete}
          autoSave={false}
          persistProgress={false}
          storageKey=""
          allowSkip={false}
          enableRouting={true}
          className="w-full"
          allowStepClick={false}
          enableDraftMode={false}
          showDraftResume={false}
          onStepChange={undefined}
          onValidation={undefined}
          onStepSave={undefined}
          initialCompletedSteps={initialCompletedSteps}
        />
      </div>
    </div>
  );
};

export default BulkBillCreate;
